import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import './OptoutConfirm.css';

function OptoutConfirm() {
  const navigate = useNavigate();
  const [mid, setMid] = useState(null);
  const [option, setOption] = useState(null);
  const [optionChoice, setOptionChoice] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("デコードしたデータ:", decoded);

        const currentTime = Date.now() / 1000;
        if (decoded.exp && decoded.exp < currentTime) {
          console.error("トークンの有効期限が切れています");
          navigate("/TokenError");
          return;
        }

        setMid(decoded.mid);
        setOption(decoded.option);
      } catch (error) {
        console.error("JWT のデコードに失敗:", error);
        navigate("/TokenError");
      }
    } else {
      console.error("JWT トークンがURLにありません");
      navigate("/TokenError");
    }
  }, [navigate]);

  useEffect(() => {
    if (option === "optout") {
      setOptionChoice("メルマガ配信停止");
    } else if (option === "quit") {
      setOptionChoice("退会");
    }
  }, [option]);

  const handleConfirm = async () => {
    if (!mid || !option) return;

    setIsSubmitting(true);

    try {
      await fetch("https://0d17oeeh23.execute-api.ap-northeast-1.amazonaws.com/prod/confirmHandler-prod", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ mid, option }),
      });
    
      navigate("/OptoutComplete", {
        state: { optionChoice: optionChoice }
      });
    } catch (error) {
      navigate("/UnexpectedError");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="submit-complete_confilm wrapper_confirm">
      <h1>{optionChoice} を実施してもよろしいですか？</h1>
      <div className='confirm_button'>
      <button className="btn_inquiry" type="button" onClick={handleConfirm} disabled={isSubmitting}>はい</button>
        <button className="btn btn_danger" type="button" onClick={() => navigate("/")}>いいえ</button>
      </div>
      <div className='confirm_h4'>
        <h4>らくらく連絡網カスタマーサポート：ra9-cs@eu-phoria.jp</h4>
      </div>
    </div>
  );
}

export default OptoutConfirm;
